import { SETTING } from '../actionTypes'

const initialState = {
    arrSetting: [],
    arrPushNotificationTopics: [],
    webTopicSubUnSubResp: {}
};

const settingReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SETTING.GET_SETTING: {
            return {
                ...state,
                arrSetting: actions.payload
            };
        }

        case SETTING.GET_PUSH_NOTIFICATION_TOPIC_SUCCESS: {
            return {
                ...state,
                arrPushNotificationTopics: actions.payload
            };
        }

        case SETTING.GET_PUSH_NOTIFICATION_TOPIC_FAILURE: {
            return {
                ...state,
                arrPushNotificationTopics: actions.payload
            };
        }
        //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - Start
        case SETTING.PUSH_NOTIFICATION_TOPIC_SUB_UNSUB_SUCCESS: {
            return {
                ...state,
                webTopicSubUnSubResp: actions.payload
            };
        }
        //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - End

        default:
            return state;
    }
};

export default settingReducer